import styled, { css } from 'styled-components';

export default styled.label`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: .5rem;
  grid-template-columns: 1fr;
  margin-bottom: 1rem;
  ${({ $horizontal }) => $horizontal && css`
    margin-bottom: 0;
  `}

  ${({ $fontWeightNormal = false }) => !$fontWeightNormal && css`
    font-weight: 700;
  `}

  ${({ $type }) => $type !== 'textarea' && css`
    align-items: center;
  `}

  ${({ $singleColumn = false }) => !$singleColumn && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      grid-gap: ${({ theme }) => theme.grid.columnGap};
      grid-template-columns: 1fr 2fr;
    }
  `}
  ${({ $standout }) => $standout && css`
    width: 100%;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      width: auto;
    }
  `}
`;
